import React, { lazy } from "react"
import { Common } from "lib/types"
import { ReactComponent as DashboardIcon } from "images/icons/chart-line.svg"
import { PermissionGroups } from "../constants"

const Home = lazy(() => import("views/Home").then(m => ({ default: m.Home })))
const Dashboards = lazy(() => import("views/Dashboards/Dashboards").then(m => ({ default: m.Dashboards })))
const DashboardsSales = lazy(() => import("views/Dashboards/DashboardsSales").then(m => ({ default: m.DashboardsSales })))
const InsightsDashboard = lazy(() => import("views/Dashboards/InsightsDashboard"))
const OperationsDashboard = lazy(() => import("../../views/Dashboards/OperationsDashboard"))
const WorkflowDashboard = lazy(() => import("views/Dashboards/WorkflowDashboard"))

export const dashboardRoutes: Common.Views = [
  {
    element: <Home />,
    path: "/",
    title: "Home",
    icon: DashboardIcon,
    sortOrder: 1
  },
  {
    element: <Dashboards />,
    path: "/dashboard",
    title: "Dashboard",
    icon: DashboardIcon,
    sortOrder: 1,
    children: [
      {
        element: <Home />,
        path: "/dashboard/home",
        title: "Home",
        parentPath: "/dashboard",
        section: "Dashboards"
      },
      {
        element: <DashboardsSales />,
        path: "/dashboard/sales",
        title: "Sales",
        parentPath: "/dashboard",
        requiredGroups: PermissionGroups.salesDashboards.read
      },
      {
        element: <InsightsDashboard />,
        path: "/dashboard/insights",
        title: "Insights",
        parentPath: "/dashboard",
        configKey: "insightsEnabled",
        requiredGroups: PermissionGroups.insightsDashboards.read
      },
      {
        element: <OperationsDashboard />,
        path: "/dashboard/operations",
        title: "Operations",
        parentPath: "/dashboard",
        configKey: "operationsEnabled",
        requiredGroups: PermissionGroups.operationsDashboards.read
      },
      {
        element: <WorkflowDashboard />,
        path: "/dashboard/workflows",
        title: "Workflows",
        parentPath: "/dashboard"
      }
    ]
  }
]
